import { render, staticRenderFns } from "./Sudoku.vue?vue&type=template&id=4aaca06b&scoped=true&"
import script from "./Sudoku.vue?vue&type=script&lang=ts&"
export * from "./Sudoku.vue?vue&type=script&lang=ts&"
import style0 from "./Sudoku.vue?vue&type=style&index=0&id=4aaca06b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaca06b",
  null
  
)

export default component.exports